import { Routes, Route, Navigate } from 'react-router-dom'

import DashboardOEM from 'Presentation/Views/Dashboard/OEM/View'
import DashboardMKP from 'Presentation/Views/Dashboard/Marketplace/View'

const DashboardRoutes = () => (
	<Routes>
		{/* Route: Dashboard OEM */}
		<Route path="production" element={<DashboardOEM />} />
		{/* Route: Dashboard OEM */}

		{/* Route: Dashboard Marketplace */}
		<Route path="retail" element={<DashboardMKP />} />
		{/* Route: Dashboard Marketplace */}

		<Route index element={<Navigate to="/dashboard/production" />} />
		<Route path="*" element={<Navigate to="/dashboard/production" />} />
	</Routes>
)

export default DashboardRoutes
